.notice {
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  color: var(--color-warning);
}
